import { Store, TrendingUp, Users, BarChart } from 'lucide-react'

const benefits = [
  {
    icon: Users,
    title: 'Reach More Customers',
    description: 'Get discovered by thousands of local customers actively looking for products like yours.'
  },
  {
    icon: TrendingUp,
    title: 'Increase Sales',
    description: 'Enable online ordering and delivery to boost revenue and serve more customers.'
  },
  {
    icon: BarChart,
    title: 'Analytics & Insights',
    description: 'Understand your customers better with detailed analytics and sales reports.'
  },
  {
    icon: Store,
    title: 'Easy Management',
    description: 'Manage your products, orders, and inventory from a single, powerful dashboard.'
  }
]

const ForBusiness = () => {
  return (
    <section id="business" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="inline-block bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              For Businesses
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Grow Your Business with Nearbies
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Join local businesses using Nearbies to reach more customers,
              increase sales, and build lasting relationships with their community.
            </p>

            <div className="space-y-6 mb-8">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon
                return (
                  <div key={index} className="flex items-start">
                    <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <Icon className="w-5 h-5 text-primary-600" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>

            <a
              href="https://tilltech.co.uk"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors shadow-lg hover:shadow-xl"
            >
              List Your Shop
            </a>
          </div>

          {/* Right: Benefits Visual */}
          <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl p-8 text-white shadow-2xl">
            <h3 className="text-2xl font-bold mb-8">What You Get</h3>

            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">🎯 Location-Based Discovery</div>
                <div className="text-primary-100">Customers find you when searching nearby</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">📱 Online Ordering</div>
                <div className="text-primary-100">Accept orders for pickup and delivery</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-3xl font-bold mb-2">💳 Flexible Payments</div>
                <div className="text-primary-100">Cash on delivery or TillTech card terminal integration</div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-primary-100">
                Built on TillTech's proven POS infrastructure, trusted by local businesses across the UK.
                Get started today and start growing your customer base.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ForBusiness
